import React, { useState } from 'react';
import { CustomAutocomplete } from './AutoComplete';

// var monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];


export  const SelectMonthAutoComplete = ({ value, onChange }) => {
    const [selectedMonth, setSelectedMonth] = useState('');

    const months = [];
    let monthName = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    let d = new Date();
    d.setDate(1);
    for (let i=0; i<=11; i++) {
        months.push(monthName[d.getMonth()] + '-' + d.getFullYear());
        d.setMonth(d.getMonth() - 1);
    }

 
    return (
        <CustomAutocomplete
        options={months}
        getOptionLabel={(option) => option}
        value={value || months[0]}
        onChange={onChange}
        label="Select Month"
      />
    );
};

